import { CheckCircleOutlined } from "@ant-design/icons";
import {
  Box,
  Card,
  CardContent,
  Container,
  Divider,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { PaymentAPIService } from "../../services/api";
import starIcon from "../../assests/Images/starIcon.png";
import lineIcon from "../../assests/Images/lineIcon2.png";
import joyLogo from "../../assests/Images/joyLogo.png";

export default function Success() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const phone = params.get("phone");
  const type = params.get("type");


  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getUpdatedStatus() {
      if (!sessionId) return;
      await PaymentAPIService.getUpdatedStatus(phone,sessionId,type);
      setLoading(false);
    }
    getUpdatedStatus();
  }, [sessionId]);

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ mt: 15, textAlign: "center" }}>
        <CircularProgress size={50} />
        <Typography variant="h6" mt={2}>
          Verifying your payment, please wait...
        </Typography>
      </Container>
    );
  }

  return (
    <Container >
         <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mb={1}
              >
                <img src={starIcon} alt="Star Icon" style={{ width: 60, height: "auto",marginTop:"40px" }} />
                <img src={joyLogo} alt="Joy Logo" style={{ width: 120, height: "auto" }} />
                <img src={lineIcon} alt="Line Icon" style={{ width: 60, height: "auto" ,marginTop:"40px"}} />
              </Box>
              <Container maxWidth="sm" >
      <Card variant="outlined" sx={{ textAlign: "center", p: 4, boxShadow: 3 }}>
        <Box display="flex" justifyContent="center" mb={2}>
          <CheckCircleOutlined style={{ fontSize: 72, color: "#4caf50" }} />
        </Box>
        <CardContent>
          <Typography variant="h4" color="success.main" gutterBottom>
            Payment Successful!
          </Typography>

          <Typography variant="body1" sx={{ mt: 1, mb: 3 }}>
            {type === "subscription" && "Your subscription is now active." } Welcome to the premium experience!
          </Typography>

          <Divider sx={{ my: 3 }} />

          <Box textAlign="left">
            <Typography variant="subtitle1"><strong>Transation ID:</strong>  <span>{sessionId}</span></Typography>
            <Typography variant="subtitle1"><strong>Payment Status:</strong> Success</Typography>
            <Typography variant="subtitle1"><strong>Access:</strong> All premium features enabled</Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
            If you have any questions or need help, feel free to contact our support team.
          </Typography>
        </CardContent>
      </Card>
      </Container>
    </Container>
  );
}
